// extracted by css-extract-rspack-plugin
export default {"boardSurface":"BoardSurface-module__boardSurface__SP1um"};